var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Absolute, Relative, Flex, BackgroundImage } from 'pcln-design-system';
import { CircleSmall, PricelineP } from '../svg-build';
var baseZindex = 1;
var CropFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var OnTopBackgroundImage = styled(BackgroundImage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), baseZindex + 4);
var CroppedImage = function (_a) {
    var imageMirrorProps = _a.imageMirrorProps, imageUrl = _a.imageUrl;
    return (React.createElement(CropFlex, __assign({ justifyContent: 'center', width: '100%', height: '100%', borderRadius: 'full' }, imageMirrorProps),
        React.createElement(OnTopBackgroundImage, { width: '100%', height: '100%', image: imageUrl })));
};
/** @public */
export var Stage = styled(Relative).attrs({
    minHeight: ['206px', null, '480px'],
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: clip;\n  ", " {\n    overflow-x: unset;\n  }\n"], ["\n  overflow: clip;\n  ", " {\n    overflow-x: unset;\n  }\n"
    /** @public */
])), themeGet('mediaQueries.md'));
/** @public */
export var StyledP = styled(PricelineP)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  transform: ", ";\n\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  transform: ", ";\n\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    /** @public */
])), function (props) { return (props.mirror === 'left' ? 'scaleX(-1)' : ''); });
/** @public */
export var StyledCircleSmall = styled(CircleSmall)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  &,\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    /** @public */
])));
/** @public */
export var CircleStage = styled(Absolute)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"
    /** @public */
])), baseZindex + 2);
/** @public */
export var PStage = styled(Absolute)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), baseZindex + 1);
export var ImageStage = styled(Absolute)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  z-index: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  ", " {\n    z-index: ", ";\n  }\n"], ["\n  z-index: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  ", " {\n    z-index: ", ";\n  }\n"
    // /** @public */
])), baseZindex + 4, themeGet('mediaQueries.md'), baseZindex);
/** @public */
var SilhouetteSemicircle = function (_a) {
    var _b = _a.mirror, mirror = _b === void 0 ? 'right' : _b, imageUrl = _a.imageUrl, className = _a.className;
    var sphereProps = mirror === 'left' ? { left: ['3%', null, '-10%', null, '-12%', '-16%'] } : { right: ['5%', null, '-10%', null, '-12%', '-16%'] };
    var P_OFFSET = ['-40%', null, '-18%'];
    var pProps = mirror === 'left' ? { right: P_OFFSET, transform: 'scaleX(-1)' } : { left: P_OFFSET };
    return (React.createElement(Stage, { className: className },
        React.createElement(CircleStage, __assign({ size: ['85px', null, '100px', null, '125px', '150px'], bottom: [null, null, '0'] }, sphereProps),
            React.createElement(StyledCircleSmall, null)),
        React.createElement(PStage, __assign({ width: ['291.04px', null, null, '400px', '450px', '551.25px'], top: ['-65%', null, '-29%', '-42%', '-52%', '-65%'] }, pProps),
            React.createElement(StyledP, { mirror: mirror })),
        React.createElement(ImageStage, { width: ['90%', null, null, null, '100%', '748px'], height: ['175px', null, '374px'], bottom: ['8%', null, null, null, '12%'], left: [0, null, '-2%', null, '-10%'], right: [0, null, '-2%', null, '-10%'] },
            React.createElement(CroppedImage, { imageUrl: imageUrl, imageMirrorProps: { rounded: 'top' } }))));
};
/** @public */
export { SilhouetteSemicircle };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=SilhouetteSemicircle.js.map